import React from "react";
import { useHistory } from "react-router";
import styles from "./HomeLoyaltyGrid.module.scss";
import {
  ROUTE_MENU,
  REACT_APP_CLOUD_FRONT,
  ROUTE_ORDER,
  GUEST_USER,
} from "../../../constants";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useAuthState } from "../../../context/UserAuthentication";
import { useStoreLocation } from "../../../context/StoreLocation";

const HomeLoyaltyGrid = () => {
  const history = useHistory();
  const isItMobile = useCheckMobileScreen();
  const { authInfo } = useAuthState();
  const { locationInfo } = useStoreLocation();

  const handleMangoMogitoRedirect = () => {
    if (authInfo.type === GUEST_USER || !locationInfo.selectedStore) {
      return `${ROUTE_MENU}/Drinks`;
    } else {
      return `${ROUTE_ORDER}/255?category_id=8`;
    }
  };
  return (
    <div className={`row ${styles.gridWrapper}`}>
      <div className="col-md-6 position-relative">
        {isItMobile ? (
          <img
            src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/mangoMojitoMobile.png`}
            alt="SunSHine"
            className="img-fluid"
            style={{ borderRadius: "15px" }}
          />
        ) : (
          <img
            src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/mangoMojitoDesktop.png`}
            alt="SunSHine"
            className="img-fluid"
            style={{ height: "100%", borderRadius: "15px" }}
          />
        )}

        <div className={styles.textWrapper}>
          <div className="d-flex flex-column align-items-end">
            <div className="d-flex gap-3 flex-nowrap">
              <p
                className={`${styles.innerText} ${styles.innerSpacing} cz-ps-sm-24 text-nowrap`}
              >
                Meet the Sunshine Shot—refreshing <br /> citrus with a serious
                immunity boost.
              </p>
              <div
                className={`${styles.innerText} ${styles.imagediv} rounded-circle opacity-0`}
              >
                <img
                  src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/leaf.png`}
                  alt="leafImage"
                />
              </div>
            </div>

            <div className="d-flex flex-nowrap gap-3">
              <a
                onClick={() => {
                  history.push(handleMangoMogitoRedirect());
                }}
                className={`${styles.innerText} ${styles.innerSpacing} ${styles.innerLink} gap-2 flex-nowrap d-flex`}
              >
                {" "}
                <span className="text-nowrap">Add it to your order </span>
                <svg
                  width="32"
                  height="23"
                  viewBox="0 0 32 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.20312 10.1292C1.3747 10.1292 0.703125 10.8007 0.703125 11.6292C0.703125 12.4576 1.3747 13.1292 2.20313 13.1292L2.20312 10.1292ZM30.6222 12.6898C31.2079 12.104 31.2079 11.1543 30.6222 10.5685L21.0762 1.02255C20.4904 0.436762 19.5407 0.436762 18.9549 1.02255C18.3691 1.60834 18.3691 2.55808 18.9549 3.14387L27.4402 11.6292L18.9549 20.1144C18.3691 20.7002 18.3691 21.65 18.9549 22.2358C19.5407 22.8215 20.4904 22.8215 21.0762 22.2358L30.6222 12.6898ZM2.20313 13.1292L29.5615 13.1292V10.1292L2.20312 10.1292L2.20313 13.1292Z"
                    fill="#FAA21D"
                  />
                </svg>
              </a>
              <div
                className={`${styles.innerText} ${styles.imagediv} rounded-circle`}
              >
                <img
                  src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/Sun.png`}
                  alt="SunImage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 mt-3 mt-md-0 position-relative">
        {!isItMobile ? (
          <img
            src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/fallBanner.png`}
            alt="VeggieImage"
            style={{ height: "100%", borderRadius: "15px" }}
            className="img-fluid"
          />
        ) : (
          <img
            src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/fallBanner.png`}
            alt="VeggieImage"
            className="img-fluid"
            style={{ borderRadius: "15px" }}
          />
        )}

        <div className={`${styles.rightTextWrapper} ${styles.textWrapper}`}>
          <div className="d-flex flex-column align-items-start">
            <div className="d-flex gap-3 flex-nowrap">
              <div
                className={`${styles.innerText} ${styles.imagediv} rounded-circle d-flex align-items-center justify-content-center `}
              >
                <img
                  src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/snow.png`}
                  alt="snowImage"
                  height={36}
                />
              </div>
              <p
                className={`${styles.innerText} ${styles.innerSpacingRight}  cz-ps-20 text-nowrap`}
              >
                It’s snowing somewhere and you <br /> know what that means....
              </p>
            </div>
            <div className="d-flex flex-nowrap gap-3">
              <div
                className={`${styles.innerText} ${styles.imagediv} rounded-circle opacity-0`}
              >
                <img
                  src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/snow.png`}
                  alt="snowImage"
                />
              </div>
              <a
                onClick={() => {
                  history.push("menu/Soups");
                }}
                className={`${styles.innerText}  ${styles.innerLink} flex-nowrap d-flex gap-2`}
              >
                {" "}
                <span className="text-nowrap">Click here for soup</span>
                <svg
                  width="32"
                  height="23"
                  viewBox="0 0 32 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.20312 10.1292C1.3747 10.1292 0.703125 10.8007 0.703125 11.6292C0.703125 12.4576 1.3747 13.1292 2.20313 13.1292L2.20312 10.1292ZM30.6222 12.6898C31.2079 12.104 31.2079 11.1543 30.6222 10.5685L21.0762 1.02255C20.4904 0.436762 19.5407 0.436762 18.9549 1.02255C18.3691 1.60834 18.3691 2.55808 18.9549 3.14387L27.4402 11.6292L18.9549 20.1144C18.3691 20.7002 18.3691 21.65 18.9549 22.2358C19.5407 22.8215 20.4904 22.8215 21.0762 22.2358L30.6222 12.6898ZM2.20313 13.1292L29.5615 13.1292V10.1292L2.20312 10.1292L2.20313 13.1292Z"
                    fill="#0956A8"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeLoyaltyGrid;
